//@flow
import React, { Component } from 'react';
import {
  CustomPerPageFilterSmall,
  CustomPerPageFilterDropdownDiv,
  CustomPerPageFilterDiv
} from './TableComponentStyles';
import TableFilter from '../../../components/TableFilter';

type Props = {
  //Filter
  currentPerPage: string,
  setPerPage: () => void,
  perPageOptions: Array<number>,
  alignWithTable?: boolean
};

export default class CustomPerPageFilter extends Component<Props> {
  render() {
    return (
      <CustomPerPageFilterDiv alignWithTable={this.props.alignWithTable}>
        <CustomPerPageFilterSmall>Show</CustomPerPageFilterSmall>
        <CustomPerPageFilterDropdownDiv>
          <TableFilter
            value={this.props.currentPerPage}
            onChange={this.props.setPerPage}
            options={this.props.perPageOptions}
            rightEnd={true}
            ignoreActiveStyles
            scale={0}
            // disabled
          />
        </CustomPerPageFilterDropdownDiv>
      </CustomPerPageFilterDiv>
    );
  }
}
